import { createServerFn } from "@tanstack/react-start";
import { siteContext } from "../server/site.server";
import { platformPageResponse } from "./page-response";
import { feeCalculatorPage } from "./tools.server";

/** /tools/patreon-fee-calculator, on Drate's own host only. */
export const loadFeeCalculator = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (drate.creator) return null;
  platformPageResponse(drate);
  return feeCalculatorPage(drate.env.APP_ORIGIN);
});
